


















































import { Component, Prop, Vue } from "vue-property-decorator";
import Box from "./Box.vue";
import { isEmailValid } from "@/helper";

import axios from "axios";

@Component({
  components: {
    Box
  }
})
class Contact extends Vue {
  name = "";
  email = "";
  phone = "";
  message = "";
  errors: Array<string> = [];

  cleanForm() {
    this.name = "";
    this.email = "";
    this.phone = "";
    this.message = "";
  }

  checkForm(e: Event) {
    this.errors = [];

    if (!this.name) {
      this.errors.push("O nome é obrigatório.");
    }
    if (!this.email) {
      this.errors.push("O e-mail é obrigatório.");
    } else if (!isEmailValid(this.email)) {
      this.errors.push("Utilize um e-mail válido.");
    }

    if (!this.message) {
      this.errors.push("A mensagem é obrigatória.");
    }

    if (!this.errors.length) {
      axios
        .post(
          "https://api.sendinblue.com/v3/smtp/email",
          {
            sender: {
              name: "Minnova",
              email: "contact@minnova.com"
            },
            to: [
              {
                email: "phcurado@gmail.com",
                name: "Paulo"
              }
            ],
            subject: `Minnova contact from ${this.email}`,
            htmlContent: `<html><head></head><body>
            <p>Nome: ${this.name}</p>
            <p>Email: ${this.email}</p>
            <p>Telefone: ${this.phone}</p>
            <p>Mensagem: ${this.message}</p>
            </body></html>`
          },
          {
            headers: {
              "api-key":
                "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"
            }
          }
        )
        .then(x => {
          alert("Email enviado com sucesso");
          this.cleanForm();
        });
    }

    e.preventDefault();
  }
}

export default Contact;
